export const posts = [
  {
    "slug": "january-hours-2025-2025-01-06",
    "title": "Read the January 2025 hours on the door and the listing, January 6, 2025",
    "seoTitle": "January 2025 hours (restaurant, January 6, 2025)",
    "description": "January 2025 hours for a restaurant on January 6, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-01-06",
    "cta": "This week, look at the hours for January 2025. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In January 2025, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This January 6, 2025 note is for a restaurant. The check is January 2025 hours: the hours for January 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for January 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for January 2025. In January 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for January 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for January 2025 before you add anything",
        "paragraphs": [
          "A mismatch on January 2025 hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the hours for January 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set New Year hours before the week starts, December 30, 2024",
        "href": "/blog/new-year-hours-2025-2024-12-30"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "ask-a-tool-then-call-2025-01-13",
    "title": "People may ask a tool and then call you, January 13, 2025",
    "seoTitle": "Customers who use AI then call (law office, January 13, 2025)",
    "description": "Customers who use AI then call for a law office on January 13, 2025. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2025-01-13",
    "cta": "This week, look at the call after someone used a tool. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Assume they read a summary that might be incomplete. Answer with the hours, the area, and the price the way the page states them.",
          "This January 13, 2025 note is for a law office. The check is customers who use AI then call: the call after someone used a tool, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the call after someone used a tool",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the call after someone used a tool. In January 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The call after someone used a tool on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the call after someone used a tool before you add anything",
        "paragraphs": [
          "A mismatch on customers who use AI then call is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the call after someone used a tool. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "A drafted service page still needs your cities, December 9, 2024",
        "href": "/blog/draft-needs-cities-2024-12-09"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "january-photo-2025-2025-01-20",
    "title": "Add one January 2025 photo of the real place, January 20, 2025",
    "seoTitle": "January 2025 business photo (retail shop, January 20, 2025)",
    "description": "January 2025 business photo for a retail shop on January 20, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-01-20",
    "cta": "This week, look at a photo from January 2025. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this January of the door, the work, or the counter. A photo from another season makes 2025 look unattended.",
          "This January 20, 2025 note is for a retail shop. The check is January 2025 business photo: a photo from January 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from January 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from January 2025. In January 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from January 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from January 2025 before you add anything",
        "paragraphs": [
          "A mismatch on January 2025 business photo is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare a photo from January 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the January 2025 hours on the door and the listing, January 6, 2025",
        "href": "/blog/january-hours-2025-2025-01-06"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "january-offer-2025-2025-01-27",
    "title": "Keep the January 2025 offer to a single dated line, January 27, 2025",
    "seoTitle": "January 2025 offer (contractor, January 27, 2025)",
    "description": "January 2025 offer for a contractor on January 27, 2025. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2025-01-27",
    "cta": "This week, look at the offer running in January 2025. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are running an offer in January 2025, put the end date in the same sentence and keep it under the phone number.",
          "This January 27, 2025 note is for a contractor. The check is January 2025 offer: the offer running in January 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the offer running in January 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the offer running in January 2025. In January 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The offer running in January 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the offer running in January 2025 before you add anything",
        "paragraphs": [
          "A mismatch on January 2025 offer is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the offer running in January 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of January 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the December popup from covering the number, December 16, 2024",
        "href": "/blog/december-popup-2024-12-16"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "no-valentine-in-the-name-2025-02-03",
    "title": "Leave the holiday out of the business name, February 3, 2025",
    "seoTitle": "Business name on Google (salon, February 3, 2025)",
    "description": "Business name on Google for a salon on February 3, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-02-03",
    "cta": "This week, look at the business name. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Adding a holiday to the name on the listing is how reviews and the map listing get split. Keep the real name.",
          "This February 3, 2025 note is for a salon. The check is business name on Google: the business name, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the business name",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the business name. In February 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The business name on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the business name before you add anything",
        "paragraphs": [
          "A mismatch on business name on Google is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare the business name. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one January 2025 photo of the real place, January 20, 2025",
        "href": "/blog/january-photo-2025-2025-01-20"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "valentine-hours-2025-2025-02-10",
    "title": "Put Valentine's week hours and the offer in one place, February 10, 2025",
    "seoTitle": "Valentine's week hours (clinic, February 10, 2025)",
    "description": "Valentine's week hours for a clinic on February 10, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-02-10",
    "cta": "This week, look at Valentine's week. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If 2025 includes a Valentine offer or a fuller book, say the hours and the last day of the offer. Leave the business name alone.",
          "This February 10, 2025 note is for a clinic. The check is Valentine's week hours: Valentine's week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Valentine's week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Valentine's week. In February 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Valentine's week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Valentine's week before you add anything",
        "paragraphs": [
          "A mismatch on Valentine's week hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare Valentine's week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Leave the holiday out of the business name, February 3, 2025",
        "href": "/blog/no-valentine-in-the-name-2025-02-03"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "call-matches-the-page-2025-02-17",
    "title": "Make the call match the page, February 17, 2025",
    "seoTitle": "Phone script and the website (restaurant, February 17, 2025)",
    "description": "Phone script and the website for a restaurant on February 17, 2025. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2025-02-17",
    "cta": "This week, look at what the phone says versus the page. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the page says a starting price, the person answering should not quote a different one.",
          "This February 17, 2025 note is for a restaurant. The check is phone script and the website: what the phone says versus the page, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at what the phone says versus the page",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at what the phone says versus the page. In February 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "What the phone says versus the page on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix what the phone says versus the page before you add anything",
        "paragraphs": [
          "A mismatch on phone script and the website is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare what the phone says versus the page. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "People may ask a tool and then call you, January 13, 2025",
        "href": "/blog/ask-a-tool-then-call-2025-01-13"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "february-entrance-2025-02-24",
    "title": "Check the entrance photo after winter weather, February 24, 2025",
    "seoTitle": "Entrance photo (law office, February 24, 2025)",
    "description": "Entrance photo for a law office on February 24, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-02-24",
    "cta": "This week, look at the entrance people should use. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A photo of a door you no longer use, or a walkway that flooded, sends the pin visit to the wrong place.",
          "This February 24, 2025 note is for a law office. The check is entrance photo: the entrance people should use, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the entrance people should use",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the entrance people should use. In February 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The entrance people should use on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the entrance people should use before you add anything",
        "paragraphs": [
          "A mismatch on entrance photo is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the entrance people should use. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of February 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Put Valentine's week hours and the offer in one place, February 10, 2025",
        "href": "/blog/valentine-hours-2025-2025-02-10"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "march-form-2025-03-03",
    "title": "Make sure the form matches a spring booking, March 3, 2025",
    "seoTitle": "Spring booking form (retail shop, March 3, 2025)",
    "description": "Spring booking form for a retail shop on March 3, 2025. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2025-03-03",
    "cta": "This week, look at what the form asks. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Ask for the job and the city. Do not ask for a life story before you have agreed to come out.",
          "This March 3, 2025 note is for a retail shop. The check is spring booking form: what the form asks, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at what the form asks",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at what the form asks. In March 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "What the form asks on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix what the form asks before you add anything",
        "paragraphs": [
          "A mismatch on spring booking form is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare what the form asks. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Test the form during the late-summer week, August 28, 2023",
        "href": "/blog/august-form-2023-08-28"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "march-hours-2025-2025-03-10",
    "title": "Read the March 2025 hours on the door and the listing, March 10, 2025",
    "seoTitle": "March 2025 hours (contractor, March 10, 2025)",
    "description": "March 2025 hours for a contractor on March 10, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-03-10",
    "cta": "This week, look at the hours for March 2025. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In March 2025, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This March 10, 2025 note is for a contractor. The check is March 2025 hours: the hours for March 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for March 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for March 2025. In March 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for March 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for March 2025 before you add anything",
        "paragraphs": [
          "A mismatch on March 2025 hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the hours for March 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Check the entrance photo after winter weather, February 24, 2025",
        "href": "/blog/february-entrance-2025-02-24"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "march-photo-2025-2025-03-17",
    "title": "Add one March 2025 photo of the real place, March 17, 2025",
    "seoTitle": "March 2025 business photo (salon, March 17, 2025)",
    "description": "March 2025 business photo for a salon on March 17, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-03-17",
    "cta": "This week, look at a photo from March 2025. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this March of the door, the work, or the counter. A photo from another season makes 2025 look unattended.",
          "This March 17, 2025 note is for a salon. The check is March 2025 business photo: a photo from March 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from March 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from March 2025. In March 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from March 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from March 2025 before you add anything",
        "paragraphs": [
          "A mismatch on March 2025 business photo is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare a photo from March 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the March 2025 hours on the door and the listing, March 10, 2025",
        "href": "/blog/march-hours-2025-2025-03-10"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "one-service-not-twenty-2025-03-24",
    "title": "Do not publish twenty pages a tool offered to write, March 24, 2025",
    "seoTitle": "Too many drafted pages (clinic, March 24, 2025)",
    "description": "Too many drafted pages for a clinic on March 24, 2025. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2025-03-24",
    "cta": "This week, look at pages you have not checked. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "One true service page is safer than a folder of unread drafts aimed at towns you do not serve.",
          "This March 24, 2025 note is for a clinic. The check is too many drafted pages: pages you have not checked, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at pages you have not checked",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at pages you have not checked. In March 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Pages you have not checked on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix pages you have not checked before you add anything",
        "paragraphs": [
          "A mismatch on too many drafted pages is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare pages you have not checked. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Make the call match the page, February 17, 2025",
        "href": "/blog/call-matches-the-page-2025-02-17"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "march-offer-2025-2025-03-31",
    "title": "Keep the March 2025 offer to a single dated line, March 31, 2025",
    "seoTitle": "March 2025 offer (restaurant, March 31, 2025)",
    "description": "March 2025 offer for a restaurant on March 31, 2025. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2025-03-31",
    "cta": "This week, look at the offer running in March 2025. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are running an offer in March 2025, put the end date in the same sentence and keep it under the phone number.",
          "This March 31, 2025 note is for a restaurant. The check is March 2025 offer: the offer running in March 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the offer running in March 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the offer running in March 2025. In March 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The offer running in March 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the offer running in March 2025 before you add anything",
        "paragraphs": [
          "A mismatch on March 2025 offer is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the offer running in March 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of March 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the January 2025 offer to a single dated line, January 27, 2025",
        "href": "/blog/january-offer-2025-2025-01-27"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "april-hours-2025-2025-04-07",
    "title": "Read the April 2025 hours on the door and the listing, April 7, 2025",
    "seoTitle": "April 2025 hours (law office, April 7, 2025)",
    "description": "April 2025 hours for a law office on April 7, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-04-07",
    "cta": "This week, look at the hours for April 2025. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In April 2025, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This April 7, 2025 note is for a law office. The check is April 2025 hours: the hours for April 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for April 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for April 2025. In April 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for April 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for April 2025 before you add anything",
        "paragraphs": [
          "A mismatch on April 2025 hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the hours for April 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one March 2025 photo of the real place, March 17, 2025",
        "href": "/blog/march-photo-2025-2025-03-17"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "easter-hours-2025-2025-04-14",
    "title": "Write Easter week hours as special hours, April 14, 2025",
    "seoTitle": "Easter week hours (retail shop, April 14, 2025)",
    "description": "Easter week hours for a retail shop on April 14, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-04-14",
    "cta": "This week, look at Easter week hours. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Easter week in 2025 is not a normal week. Mark the day you close, and leave the rest of the weekly schedule as the days you are open.",
          "This April 14, 2025 note is for a retail shop. The check is Easter week hours: Easter week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Easter week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Easter week hours. In April 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Easter week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Easter week hours before you add anything",
        "paragraphs": [
          "A mismatch on Easter week hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare Easter week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the April 2025 hours on the door and the listing, April 7, 2025",
        "href": "/blog/april-hours-2025-2025-04-07"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "april-photo-2025-2025-04-21",
    "title": "Add one April 2025 photo of the real place, April 21, 2025",
    "seoTitle": "April 2025 business photo (contractor, April 21, 2025)",
    "description": "April 2025 business photo for a contractor on April 21, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-04-21",
    "cta": "This week, look at a photo from April 2025. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this April of the door, the work, or the counter. A photo from another season makes 2025 look unattended.",
          "This April 21, 2025 note is for a contractor. The check is April 2025 business photo: a photo from April 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from April 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from April 2025. In April 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from April 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from April 2025 before you add anything",
        "paragraphs": [
          "A mismatch on April 2025 business photo is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare a photo from April 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Easter week hours as special hours, April 14, 2025",
        "href": "/blog/easter-hours-2025-2025-04-14"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "form-still-reaches-a-person-2025-04-28",
    "title": "Make sure the form still reaches a person, April 28, 2025",
    "seoTitle": "Contact form delivery (salon, April 28, 2025)",
    "description": "Contact form delivery for a salon on April 28, 2025. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2025-04-28",
    "cta": "This week, look at where the form goes. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A polished page with a form that lands nowhere is a dead end, summary or not.",
          "This April 28, 2025 note is for a salon. The check is contact form delivery: where the form goes, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at where the form goes",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at where the form goes. In April 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Where the form goes on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix where the form goes before you add anything",
        "paragraphs": [
          "A mismatch on contact form delivery is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare where the form goes. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of April 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Do not publish twenty pages a tool offered to write, March 24, 2025",
        "href": "/blog/one-service-not-twenty-2025-03-24"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "mother-hours-2025-2025-05-05",
    "title": "Say how Mother's Day bookings work this year, May 5, 2025",
    "seoTitle": "Mother's Day bookings (clinic, May 5, 2025)",
    "description": "Mother's Day bookings for a clinic on May 5, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-05-05",
    "cta": "This week, look at Mother's Day bookings. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The week of Mother's Day in 2025 fills early for a lot of shops. Say whether you are taking reservations, walk-ins, or neither, and the hour you stop.",
          "This May 5, 2025 note is for a clinic. The check is Mother's Day bookings: Mother's Day bookings, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Mother's Day bookings",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Mother's Day bookings. In May 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Mother's Day bookings on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Mother's Day bookings before you add anything",
        "paragraphs": [
          "A mismatch on Mother's Day bookings is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare Mother's Day bookings. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one April 2025 photo of the real place, April 21, 2025",
        "href": "/blog/april-photo-2025-2025-04-21"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "may-wait-time-2025-05-12",
    "title": "Publish the real wait for a May appointment, May 12, 2025",
    "seoTitle": "May appointment wait (restaurant, May 12, 2025)",
    "description": "May appointment wait for a restaurant on May 12, 2025. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2025-05-12",
    "cta": "This week, look at how long until the next opening. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are two weeks out, say two weeks. A 'same day' line you cannot keep is the review.",
          "This May 12, 2025 note is for a restaurant. The check is May appointment wait: how long until the next opening, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how long until the next opening",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how long until the next opening. In May 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How long until the next opening on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how long until the next opening before you add anything",
        "paragraphs": [
          "A mismatch on May appointment wait is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare how long until the next opening. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the March 2025 offer to a single dated line, March 31, 2025",
        "href": "/blog/march-offer-2025-2025-03-31"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "memorial-week-follow-2025-05-19",
    "title": "Restore normal hours after the long weekend, May 19, 2025",
    "seoTitle": "Hours after Memorial Day (law office, May 19, 2025)",
    "description": "Hours after Memorial Day for a law office on May 19, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-05-19",
    "cta": "This week, look at the week after a long weekend. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Special hours should end when the weekend ends. Check Monday morning that the listing is back to the real week.",
          "This May 19, 2025 note is for a law office. The check is hours after Memorial Day: the week after a long weekend, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the week after a long weekend",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the week after a long weekend. In May 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The week after a long weekend on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the week after a long weekend before you add anything",
        "paragraphs": [
          "A mismatch on hours after Memorial Day is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the week after a long weekend. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Say how Mother's Day bookings work this year, May 5, 2025",
        "href": "/blog/mother-hours-2025-2025-05-05"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "memorial-hours-2025-2025-05-26",
    "title": "Mark Memorial Day on the listing, May 26, 2025",
    "seoTitle": "Memorial Day hours (retail shop, May 26, 2025)",
    "description": "Memorial Day hours for a retail shop on May 26, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-05-26",
    "cta": "This week, look at Memorial Day hours. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Memorial Day 2025 is a Monday. If you are closed, the weekly Monday hours will still look open unless you add a special hour.",
          "This May 26, 2025 note is for a retail shop. The check is Memorial Day hours: Memorial Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Memorial Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Memorial Day hours. In May 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Memorial Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Memorial Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Memorial Day hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare Memorial Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of May 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Restore normal hours after the long weekend, May 19, 2025",
        "href": "/blog/memorial-week-follow-2025-05-19"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "reviews-are-from-customers-2025-06-02",
    "title": "Leave reviews to customers, June 2, 2025",
    "seoTitle": "Real Google reviews (contractor, June 2, 2025)",
    "description": "Real Google reviews for a contractor on June 2, 2025. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2025-06-02",
    "cta": "This week, look at reviews written by customers. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Do not generate praise. Reply to the reviews people actually left.",
          "This June 2, 2025 note is for a contractor. The check is real Google reviews: reviews written by customers, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at reviews written by customers",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at reviews written by customers. In June 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Reviews written by customers on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix reviews written by customers before you add anything",
        "paragraphs": [
          "A mismatch on real Google reviews is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare reviews written by customers. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Make sure the form still reaches a person, April 28, 2025",
        "href": "/blog/form-still-reaches-a-person-2025-04-28"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "father-hours-2025-2025-06-09",
    "title": "Set Father's Day week hours and capacity, June 9, 2025",
    "seoTitle": "Father's Day hours (salon, June 9, 2025)",
    "description": "Father's Day hours for a salon on June 9, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-06-09",
    "cta": "This week, look at Father's Day week. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If Father's Day 2025 changes the book or the menu, put the hours and the limit on the listing. Take it down the next week.",
          "This June 9, 2025 note is for a salon. The check is Father's Day hours: Father's Day week, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Father's Day week",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Father's Day week. In June 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Father's Day week on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Father's Day week before you add anything",
        "paragraphs": [
          "A mismatch on Father's Day hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Father's Day week. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Memorial Day on the listing, May 26, 2025",
        "href": "/blog/memorial-hours-2025-2025-05-26"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "vacation-coverage-2025-06-16",
    "title": "Name who covers the phone during vacations, June 16, 2025",
    "seoTitle": "Vacation phone coverage (clinic, June 16, 2025)",
    "description": "Vacation phone coverage for a clinic on June 16, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-06-16",
    "cta": "This week, look at who answers during a vacation. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If the lead tech or the owner is out, the listing still needs a person. Say the hours that person keeps.",
          "This June 16, 2025 note is for a clinic. The check is vacation phone coverage: who answers during a vacation, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at who answers during a vacation",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at who answers during a vacation. In June 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Who answers during a vacation on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix who answers during a vacation before you add anything",
        "paragraphs": [
          "A mismatch on vacation phone coverage is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare who answers during a vacation. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Father's Day week hours and capacity, June 9, 2025",
        "href": "/blog/father-hours-2025-2025-06-09"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "friday-half-day-2025-06-23",
    "title": "Write Friday's real close if it is early, June 23, 2025",
    "seoTitle": "Friday closing time (restaurant, June 23, 2025)",
    "description": "Friday closing time for a restaurant on June 23, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-06-23",
    "cta": "This week, look at Friday's close. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A Friday that ends at three has to say three. The weekly template that says six is the mistake.",
          "This June 23, 2025 note is for a restaurant. The check is Friday closing time: Friday's close, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Friday's close",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Friday's close. In June 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Friday's close on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Friday's close before you add anything",
        "paragraphs": [
          "A mismatch on Friday closing time is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Friday's close. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Name who covers the phone during vacations, June 16, 2025",
        "href": "/blog/vacation-coverage-2025-06-16"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "july4-hours-2025-2025-06-30",
    "title": "Write July 4 hours before the weekend, June 30, 2025",
    "seoTitle": "July 4 hours (law office, June 30, 2025)",
    "description": "July 4 hours for a law office on June 30, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-06-30",
    "cta": "This week, look at July 4 hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Set July 4, 2025 hours on the profile. A short summary in search can repeat an old hour, so the profile has to be the one that is right.",
          "This June 30, 2025 note is for a law office. The check is July 4 hours: July 4 hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at July 4 hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at July 4 hours. In June 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "July 4 hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix July 4 hours before you add anything",
        "paragraphs": [
          "A mismatch on July 4 hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare July 4 hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of June 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Friday's real close if it is early, June 23, 2025",
        "href": "/blog/friday-half-day-2025-06-23"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "link-worth-opening-2025-2025-07-07",
    "title": "Make the link worth opening under the summary, July 7, 2025",
    "seoTitle": "Page under an AI Overview (retail shop, July 7, 2025)",
    "description": "Page under an AI Overview for a retail shop on July 7, 2025. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2025-07-07",
    "cta": "This week, look at why the page is worth opening. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In 2025 the summary sits above the links. The page has to add the price, the photos, and the button the summary does not have.",
          "This July 7, 2025 note is for a retail shop. The check is page under an AI Overview: why the page is worth opening, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at why the page is worth opening",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at why the page is worth opening. In July 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Why the page is worth opening on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix why the page is worth opening before you add anything",
        "paragraphs": [
          "A mismatch on page under an AI Overview is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare why the page is worth opening. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Leave reviews to customers, June 2, 2025",
        "href": "/blog/reviews-are-from-customers-2025-06-02"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "july-reviews-2025-07-14",
    "title": "Reply to reviews that mention a wait, July 14, 2025",
    "seoTitle": "Replies to wait-time reviews (contractor, July 14, 2025)",
    "description": "Replies to wait-time reviews for a contractor on July 14, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-07-14",
    "cta": "This week, look at reviews that mention a wait. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "A note that says you were behind in July needs a calm reply and, if it is true, a page that warns the next person.",
          "This July 14, 2025 note is for a contractor. The check is replies to wait-time reviews: reviews that mention a wait, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at reviews that mention a wait",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at reviews that mention a wait. In July 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Reviews that mention a wait on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix reviews that mention a wait before you add anything",
        "paragraphs": [
          "A mismatch on replies to wait-time reviews is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare reviews that mention a wait. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write July 4 hours before the weekend, June 30, 2025",
        "href": "/blog/july4-hours-2025-2025-06-30"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "july-tracking-2025-07-21",
    "title": "Know which calls came from the listing, July 21, 2025",
    "seoTitle": "Calls from the listing (salon, July 21, 2025)",
    "description": "Calls from the listing for a salon on July 21, 2025. What to check so the website and Google listing agree.",
    "section": "Site speed",
    "date": "2025-07-21",
    "cta": "This week, look at whether listing calls are counted. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "You do not need a complicated setup. You do need to know if the number on the listing is the one that rings.",
          "This July 21, 2025 note is for a salon. The check is calls from the listing: whether listing calls are counted, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at whether listing calls are counted",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at whether listing calls are counted. In July 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Whether listing calls are counted on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix whether listing calls are counted before you add anything",
        "paragraphs": [
          "A mismatch on calls from the listing is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare whether listing calls are counted. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "The old analytics property stopped taking visits, July 10, 2023",
        "href": "/blog/universal-analytics-stopped-2023-2023-07-10"
      },
      {
        "title": "Core Web Vitals for a Local Service Business",
        "href": "/blog/core-web-vitals-for-a-local-service-business"
      }
    ]
  },
  {
    "slug": "july-hours-2025-2025-07-28",
    "title": "Read the July 2025 hours on the door and the listing, July 28, 2025",
    "seoTitle": "July 2025 hours (clinic, July 28, 2025)",
    "description": "July 2025 hours for a clinic on July 28, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-07-28",
    "cta": "This week, look at the hours for July 2025. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In July 2025, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This July 28, 2025 note is for a clinic. The check is July 2025 hours: the hours for July 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for July 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for July 2025. In July 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for July 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for July 2025 before you add anything",
        "paragraphs": [
          "A mismatch on July 2025 hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the hours for July 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of July 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Reply to reviews that mention a wait, July 14, 2025",
        "href": "/blog/july-reviews-2025-07-14"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "august-hours-2025-2025-08-04",
    "title": "Read the August 2025 hours on the door and the listing, August 4, 2025",
    "seoTitle": "August 2025 hours (restaurant, August 4, 2025)",
    "description": "August 2025 hours for a restaurant on August 4, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-08-04",
    "cta": "This week, look at the hours for August 2025. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In August 2025, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This August 4, 2025 note is for a restaurant. The check is August 2025 hours: the hours for August 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for August 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for August 2025. In August 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for August 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for August 2025 before you add anything",
        "paragraphs": [
          "A mismatch on August 2025 hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the hours for August 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the July 2025 hours on the door and the listing, July 28, 2025",
        "href": "/blog/july-hours-2025-2025-07-28"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "school-hours-2025-2025-08-11",
    "title": "Publish back-to-school hours the week they start, August 11, 2025",
    "seoTitle": "Back-to-school hours (law office, August 11, 2025)",
    "description": "Back-to-school hours for a law office on August 11, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-08-11",
    "cta": "This week, look at back-to-school hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "School schedules in 2025 change the rush hour. Write the hours you will keep once classes start, on the listing and the page.",
          "This August 11, 2025 note is for a law office. The check is back-to-school hours: back-to-school hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at back-to-school hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at back-to-school hours. In August 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Back-to-school hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix back-to-school hours before you add anything",
        "paragraphs": [
          "A mismatch on back-to-school hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare back-to-school hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the August 2025 hours on the door and the listing, August 4, 2025",
        "href": "/blog/august-hours-2025-2025-08-04"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "summary-wrong-fix-profile-2026-2025-08-18",
    "title": "If a summary is wrong, fix the profile and the page, August 18, 2025",
    "seoTitle": "Incorrect AI Overview (retail shop, August 18, 2025)",
    "description": "Incorrect AI Overview for a retail shop on August 18, 2025. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2025-08-18",
    "cta": "This week, look at a wrong summary. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "You cannot edit the summary like a document. You can correct the hours, the services, and the phone on the profile and the site.",
          "This August 18, 2025 note is for a retail shop. The check is incorrect AI Overview: a wrong summary, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a wrong summary",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a wrong summary. In August 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A wrong summary on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a wrong summary before you add anything",
        "paragraphs": [
          "A mismatch on incorrect AI Overview is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare a wrong summary. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Make the link worth opening under the summary, July 7, 2025",
        "href": "/blog/link-worth-opening-2025-2025-07-07"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "august-photo-2025-2025-08-25",
    "title": "Add one August 2025 photo of the real place, August 25, 2025",
    "seoTitle": "August 2025 business photo (contractor, August 25, 2025)",
    "description": "August 2025 business photo for a contractor on August 25, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-08-25",
    "cta": "This week, look at a photo from August 2025. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this August of the door, the work, or the counter. A photo from another season makes 2025 look unattended.",
          "This August 25, 2025 note is for a contractor. The check is August 2025 business photo: a photo from August 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from August 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from August 2025. In August 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from August 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from August 2025 before you add anything",
        "paragraphs": [
          "A mismatch on August 2025 business photo is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare a photo from August 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of August 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish back-to-school hours the week they start, August 11, 2025",
        "href": "/blog/school-hours-2025-2025-08-11"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "labor-hours-2025-2025-09-01",
    "title": "Mark Labor Day closed if the door will be locked, September 1, 2025",
    "seoTitle": "Labor Day hours (salon, September 1, 2025)",
    "description": "Labor Day hours for a salon on September 1, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-09-01",
    "cta": "This week, look at Labor Day hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Labor Day 2025 is a Monday. Add the special hour. A description that mentions the holiday is not a substitute.",
          "This September 1, 2025 note is for a salon. The check is Labor Day hours: Labor Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Labor Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Labor Day hours. In September 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Labor Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Labor Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Labor Day hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Labor Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one August 2025 photo of the real place, August 25, 2025",
        "href": "/blog/august-photo-2025-2025-08-25"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "september-hours-2025-2025-09-08",
    "title": "Read the September 2025 hours on the door and the listing, September 8, 2025",
    "seoTitle": "September 2025 hours (clinic, September 8, 2025)",
    "description": "September 2025 hours for a clinic on September 8, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-09-08",
    "cta": "This week, look at the hours for September 2025. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In September 2025, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This September 8, 2025 note is for a clinic. The check is September 2025 hours: the hours for September 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for September 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for September 2025. In September 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for September 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for September 2025 before you add anything",
        "paragraphs": [
          "A mismatch on September 2025 hours is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the hours for September 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Mark Labor Day closed if the door will be locked, September 1, 2025",
        "href": "/blog/labor-hours-2025-2025-09-01"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "september-photo-2025-2025-09-15",
    "title": "Add one September 2025 photo of the real place, September 15, 2025",
    "seoTitle": "September 2025 business photo (restaurant, September 15, 2025)",
    "description": "September 2025 business photo for a restaurant on September 15, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-09-15",
    "cta": "This week, look at a photo from September 2025. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this September of the door, the work, or the counter. A photo from another season makes 2025 look unattended.",
          "This September 15, 2025 note is for a restaurant. The check is September 2025 business photo: a photo from September 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from September 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from September 2025. In September 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from September 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from September 2025 before you add anything",
        "paragraphs": [
          "A mismatch on September 2025 business photo is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare a photo from September 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the September 2025 hours on the door and the listing, September 8, 2025",
        "href": "/blog/september-hours-2025-2025-09-08"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "compare-summary-with-door-2025-09-22",
    "title": "Compare a summary with the door, September 22, 2025",
    "seoTitle": "AI Overview versus the door (law office, September 22, 2025)",
    "description": "AI Overview versus the door for a law office on September 22, 2025. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2025-09-22",
    "cta": "This week, look at the summary versus the door. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Read the summary on a phone, then look at the hours on the door. Change whichever source is wrong.",
          "This September 22, 2025 note is for a law office. The check is AI Overview versus the door: the summary versus the door, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the summary versus the door",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the summary versus the door. In September 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The summary versus the door on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the summary versus the door before you add anything",
        "paragraphs": [
          "A mismatch on AI Overview versus the door is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the summary versus the door. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "If a summary is wrong, fix the profile and the page, August 18, 2025",
        "href": "/blog/summary-wrong-fix-profile-2026-2025-08-18"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "september-offer-2025-2025-09-29",
    "title": "Keep the September 2025 offer to a single dated line, September 29, 2025",
    "seoTitle": "September 2025 offer (retail shop, September 29, 2025)",
    "description": "September 2025 offer for a retail shop on September 29, 2025. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2025-09-29",
    "cta": "This week, look at the offer running in September 2025. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are running an offer in September 2025, put the end date in the same sentence and keep it under the phone number.",
          "This September 29, 2025 note is for a retail shop. The check is September 2025 offer: the offer running in September 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the offer running in September 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the offer running in September 2025. In September 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The offer running in September 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the offer running in September 2025 before you add anything",
        "paragraphs": [
          "A mismatch on September 2025 offer is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare the offer running in September 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of September 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish the real wait for a May appointment, May 12, 2025",
        "href": "/blog/may-wait-time-2025-05-12"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "october-hours-2025-2025-10-06",
    "title": "Read the October 2025 hours on the door and the listing, October 6, 2025",
    "seoTitle": "October 2025 hours (contractor, October 6, 2025)",
    "description": "October 2025 hours for a contractor on October 6, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-10-06",
    "cta": "This week, look at the hours for October 2025. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "In October 2025, the useful check is the schedule you are actually keeping. Read the listing and the door the same morning.",
          "This October 6, 2025 note is for a contractor. The check is October 2025 hours: the hours for October 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the hours for October 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the hours for October 2025. In October 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The hours for October 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the hours for October 2025 before you add anything",
        "paragraphs": [
          "A mismatch on October 2025 hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare the hours for October 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one September 2025 photo of the real place, September 15, 2025",
        "href": "/blog/september-photo-2025-2025-09-15"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "october-photo-2025-2025-10-13",
    "title": "Add one October 2025 photo of the real place, October 13, 2025",
    "seoTitle": "October 2025 business photo (salon, October 13, 2025)",
    "description": "October 2025 business photo for a salon on October 13, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-10-13",
    "cta": "This week, look at a photo from October 2025. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Take one picture this October of the door, the work, or the counter. A photo from another season makes 2025 look unattended.",
          "This October 13, 2025 note is for a salon. The check is October 2025 business photo: a photo from October 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at a photo from October 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at a photo from October 2025. In October 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "A photo from October 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix a photo from October 2025 before you add anything",
        "paragraphs": [
          "A mismatch on October 2025 business photo is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare a photo from October 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Read the October 2025 hours on the door and the listing, October 6, 2025",
        "href": "/blog/october-hours-2025-2025-10-06"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "october-offer-2025-2025-10-20",
    "title": "Keep the October 2025 offer to a single dated line, October 20, 2025",
    "seoTitle": "October 2025 offer (clinic, October 20, 2025)",
    "description": "October 2025 offer for a clinic on October 20, 2025. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2025-10-20",
    "cta": "This week, look at the offer running in October 2025. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are running an offer in October 2025, put the end date in the same sentence and keep it under the phone number.",
          "This October 20, 2025 note is for a clinic. The check is October 2025 offer: the offer running in October 2025, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the offer running in October 2025",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the offer running in October 2025. In October 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The offer running in October 2025 on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the offer running in October 2025 before you add anything",
        "paragraphs": [
          "A mismatch on October 2025 offer is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the offer running in October 2025. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Keep the September 2025 offer to a single dated line, September 29, 2025",
        "href": "/blog/september-offer-2025-2025-09-29"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "halloween-hours-2025-2025-10-27",
    "title": "Publish Halloween day hours, October 27, 2025",
    "seoTitle": "Halloween hours (restaurant, October 27, 2025)",
    "description": "Halloween hours for a restaurant on October 27, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-10-27",
    "cta": "This week, look at Halloween day hours. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Halloween 2025 often means an earlier close or a later door. Write the day itself, not a vague seasonal note.",
          "This October 27, 2025 note is for a restaurant. The check is Halloween hours: Halloween day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Halloween day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Halloween day hours. In October 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Halloween day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Halloween day hours before you add anything",
        "paragraphs": [
          "A mismatch on Halloween hours is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare Halloween day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of October 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Add one October 2025 photo of the real place, October 13, 2025",
        "href": "/blog/october-photo-2025-2025-10-13"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "do-not-let-overview-be-the-only-pitch-2025-11-03",
    "title": "Do not let a summary be the only pitch, November 3, 2025",
    "seoTitle": "AI Overview is not the pitch (law office, November 3, 2025)",
    "description": "AI Overview is not the pitch for a law office on November 3, 2025. What to check so the website and Google listing agree.",
    "section": "Search",
    "date": "2025-11-03",
    "cta": "This week, look at the page you still need. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The summary can start the interest. The page has to finish it with a way to call.",
          "This November 3, 2025 note is for a law office. The check is AI Overview is not the pitch: the page you still need, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the page you still need",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the page you still need. In November 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The page you still need on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the page you still need before you add anything",
        "paragraphs": [
          "A mismatch on AI Overview is not the pitch is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the page you still need. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Compare a summary with the door, September 22, 2025",
        "href": "/blog/compare-summary-with-door-2025-09-22"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "veterans-hours-2025-2025-11-10",
    "title": "Set Veterans Day hours if you close, November 10, 2025",
    "seoTitle": "Veterans Day hours (retail shop, November 10, 2025)",
    "description": "Veterans Day hours for a retail shop on November 10, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-11-10",
    "cta": "This week, look at Veterans Day hours. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you close or shorten Veterans Day 2025, write that day on the listing. The weekly schedule does not know the holiday.",
          "This November 10, 2025 note is for a retail shop. The check is Veterans Day hours: Veterans Day hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Veterans Day hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Veterans Day hours. In November 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Veterans Day hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Veterans Day hours before you add anything",
        "paragraphs": [
          "A mismatch on Veterans Day hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare Veterans Day hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Publish Halloween day hours, October 27, 2025",
        "href": "/blog/halloween-hours-2025-2025-10-27"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "large-orders-2025-11-17",
    "title": "Explain large or holiday orders, November 17, 2025",
    "seoTitle": "Large order instructions (contractor, November 17, 2025)",
    "description": "Large order instructions for a contractor on November 17, 2025. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2025-11-17",
    "cta": "This week, look at how a large order works. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Lead time, how to pay, and when it is ready. If you cannot take them, say that on the page people are reading.",
          "This November 17, 2025 note is for a contractor. The check is large order instructions: how a large order works, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at how a large order works",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at how a large order works. In November 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "How a large order works on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix how a large order works before you add anything",
        "paragraphs": [
          "A mismatch on large order instructions is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare how a large order works. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Update the July menu or service list, July 8, 2024",
        "href": "/blog/july-menu-2024-07-08"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "thanksgiving-hours-2025-2025-11-24",
    "title": "Write Thanksgiving week hours before Monday, November 24, 2025",
    "seoTitle": "Thanksgiving hours (salon, November 24, 2025)",
    "description": "Thanksgiving hours for a salon on November 24, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-11-24",
    "cta": "This week, look at Thanksgiving week hours. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Put Thanksgiving 2025 hours on the profile before the week begins. A summary above the links can be stale. The hours field is what you control.",
          "This November 24, 2025 note is for a salon. The check is Thanksgiving hours: Thanksgiving week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Thanksgiving week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Thanksgiving week hours. In November 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Thanksgiving week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Thanksgiving week hours before you add anything",
        "paragraphs": [
          "A mismatch on Thanksgiving hours is worth more than a redesign. Fix that one line for this salon and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one salon page and the Google listing. Compare Thanksgiving week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of November 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Set Veterans Day hours if you close, November 10, 2025",
        "href": "/blog/veterans-hours-2025-2025-11-10"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "december-menu-2025-12-01",
    "title": "Publish the December menu people are ordering from, December 1, 2025",
    "seoTitle": "December menu (clinic, December 1, 2025)",
    "description": "December menu for a clinic on December 1, 2025. What to check so the website and Google listing agree.",
    "section": "Websites",
    "date": "2025-12-01",
    "cta": "This week, look at the menu you are serving. If it matches what the front desk would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Holiday plates in, retired plates out, as text. Do it the week the kitchen changes, not after.",
          "This December 1, 2025 note is for a clinic. The check is December menu: the menu you are serving, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the menu you are serving",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the menu you are serving. In December 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the front desk would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The menu you are serving on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the menu you are serving before you add anything",
        "paragraphs": [
          "A mismatch on December menu is worth more than a redesign. Fix that one line for this clinic and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one clinic page and the Google listing. Compare the menu you are serving. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Explain large or holiday orders, November 17, 2025",
        "href": "/blog/large-orders-2025-11-17"
      },
      {
        "title": "What to Put on a Local Service Page",
        "href": "/blog/what-to-put-on-a-local-service-page"
      }
    ]
  },
  {
    "slug": "after-christmas-listing-2025-12-08",
    "title": "Reopen the listing the morning you reopen, December 8, 2025",
    "seoTitle": "Hours after Christmas (restaurant, December 8, 2025)",
    "description": "Hours after Christmas for a restaurant on December 8, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-12-08",
    "cta": "This week, look at the first open day after Christmas. If it matches what the host stand would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "If you are open the 26th, the special hours should not still say closed. Check before you unlock the door.",
          "This December 8, 2025 note is for a restaurant. The check is hours after Christmas: the first open day after Christmas, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the first open day after Christmas",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the first open day after Christmas. In December 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the host stand would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The first open day after Christmas on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the first open day after Christmas before you add anything",
        "paragraphs": [
          "A mismatch on hours after Christmas is worth more than a redesign. Fix that one line for this restaurant and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one restaurant page and the Google listing. Compare the first open day after Christmas. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Write Thanksgiving week hours before Monday, November 24, 2025",
        "href": "/blog/thanksgiving-hours-2025-2025-11-24"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "december-phone-tree-2025-12-15",
    "title": "Match the phone greeting to December hours, December 15, 2025",
    "seoTitle": "Phone greeting hours (law office, December 15, 2025)",
    "description": "Phone greeting hours for a law office on December 15, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-12-15",
    "cta": "This week, look at the greeting on the phone. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "The recording and the listing should name the same closed days. People trust whichever they hear first.",
          "This December 15, 2025 note is for a law office. The check is phone greeting hours: the greeting on the phone, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at the greeting on the phone",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at the greeting on the phone. In December 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "The greeting on the phone on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix the greeting on the phone before you add anything",
        "paragraphs": [
          "A mismatch on phone greeting hours is worth more than a redesign. Fix that one line for this law office and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one law office page and the Google listing. Compare the greeting on the phone. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Reopen the listing the morning you reopen, December 8, 2025",
        "href": "/blog/after-christmas-listing-2025-12-08"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "christmas-hours-2025-2025-12-22",
    "title": "Separate Christmas Eve, Christmas Day, and the days after, December 22, 2025",
    "seoTitle": "Christmas hours (retail shop, December 22, 2025)",
    "description": "Christmas hours for a retail shop on December 22, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-12-22",
    "cta": "This week, look at Christmas week hours. If it matches what the counter would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write each closed day of Christmas week 2025 on the profile. Do not trust a generated summary to know you are shut.",
          "This December 22, 2025 note is for a retail shop. The check is Christmas hours: Christmas week hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at Christmas week hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at Christmas week hours. In December 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the counter would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "Christmas week hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix Christmas week hours before you add anything",
        "paragraphs": [
          "A mismatch on Christmas hours is worth more than a redesign. Fix that one line for this retail shop and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one retail shop page and the Google listing. Compare Christmas week hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Match the phone greeting to December hours, December 15, 2025",
        "href": "/blog/december-phone-tree-2025-12-15"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  },
  {
    "slug": "new-year-hours-2026-2025-12-29",
    "title": "Set New Year hours before the week starts, December 29, 2025",
    "seoTitle": "New Year hours (contractor, December 29, 2025)",
    "description": "New Year hours for a contractor on December 29, 2025. What to check so the website and Google listing agree.",
    "section": "Local SEO",
    "date": "2025-12-29",
    "cta": "This week, look at New Year hours. If it matches what the person who answers the phone would say, you are already ahead of a stale page.",
    "sections": [
      {
        "paragraphs": [
          "Write New Year hours on the profile and the contact page for 2026. Check them on a phone, because that is where people look the night before.",
          "This December 29, 2025 note is for a contractor. The check is New Year hours: New Year hours, read the way a new customer would on a phone."
        ]
      },
      {
        "heading": "1. Look at New Year hours",
        "paragraphs": [
          "Open the listing and the website on a phone. Look only at New Year hours. In December 2025 that is the piece a new customer is most likely to trust or doubt.",
          "Say the sentence out loud the way the person who answers the phone would say it. If the page uses a different name for the job, change the page, not the staff."
        ],
        "list": [
          "New Year hours on the Google listing.",
          "The same fact on the website, in the same words.",
          "What the person answering the phone would say this week."
        ]
      },
      {
        "heading": "2. Fix New Year hours before you add anything",
        "paragraphs": [
          "A mismatch on New Year hours is worth more than a redesign. Fix that one line for this contractor and leave the rest of the site alone until the listing and the page agree.",
          "Then look again tomorrow. Listings and pages sometimes show the old text for a day. The version a customer sees is the one that counts."
        ]
      },
      {
        "heading": "A check you can finish this week",
        "paragraphs": [
          "Pick one contractor page and the Google listing. Compare New Year hours. Write down the one line that disagrees, and change it before you add anything new.",
          "The tools of December 2025 only help if they describe the business you are actually running."
        ]
      }
    ],
    "relatedHeading": "Related notes",
    "relatedIntro": "These notes cover the same kind of check, with a longer guide when you want the full version.",
    "upcoming": [
      {
        "title": "Separate Christmas Eve, Christmas Day, and the days after, December 22, 2025",
        "href": "/blog/christmas-hours-2025-2025-12-22"
      },
      {
        "title": "Google Business Profile for a Service-Area Business",
        "href": "/blog/google-business-profile-for-a-service-area-business"
      }
    ]
  }
];
